// DetailsComponent.js

import styles from "@/components/ui/cards/DetailsComponent.module.css";
import ToggleSwitch from "@/components/ui/toggle/ToggleSwitch";
import ToolTip from "@/components/ui/tooltip/ToolTip";

const DetailsComponent = ({
                            title,
                            children,
                            toolTipText = null,
                            showToggle = false,
                            onToggle,
                          }) => {
  return (
    <div className={styles.detailsCard}>
      <div className={styles.detailsHeader}>
        <div className={styles.detailsTitle}>
          <div className={styles.detailsText}>{title}</div>

          <div className={styles.detailsToolTip}>
            {toolTipText && (
              <ToolTip tooltipText={toolTipText}>
                <span>?</span>
              </ToolTip>
            )}
          </div>
        </div>
        {showToggle && (
          <ToggleSwitch initialState={false} onChange={onToggle}/>
        )}
      </div>
      {children}
    </div>
  );
};

export default DetailsComponent;
